<template>
  <div
    class="base-description"
    :class="{'base-description--no-bottom-space': noBottomSpace}"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: 'base-description',
  props: {
    noBottomSpace: Boolean
  }
}
</script>

<style lang="scss">
  .base-description {
    font-size: 1.2em;

    &--no-bottom-space {
      > *:last-child {
        margin-bottom: 0;
      }
    }
  }
</style>
